var youbora = require('youboralib')
var manifest = require('../../manifest.json')

var FreewheelAdsAdapter = youbora.Adapter.extend({
    getVersion: function () {
        if (typeof google !== 'undefined' && google.ima) {
            if (this.player.FreeWheelPlugin && this.player.FreeWheelPlugin.version) {
                return "bcove-ima " + this.player.FreeWheelPlugin.version + " / IMA" + google.ima.VERSION
            } else {
                return "bcove-ima " + google.ima.VERSION
            }
        } else if (this.player.FreeWheelPlugin.getVersion) {
            return "bcove-fw " + this.player.FreeWheelPlugin.getVersion()
        } else if (this.player.FreeWheelPlugin.VERSION) {
            return "bcove-ssai " + this.player.FreeWheelPlugin.VERSION
        } else {
            return "UNKNOWN"
        }
    },

    getDuration: function () {
        var player = this.plugin.player
        if (this.player.FreeWheelPlugin) {
            if (this.player.FreeWheelPlugin.adPlayer) {
                player = this.player.FreeWheelPlugin.adPlayer
            }
        } else if (this.player.ima3) {
            player = this.player.ima3.adPlayer
        }
        return (player && player.duration) ? player.duration() : null
    },

    getPosition: function () {
        if (this.player.FreeWheelPlugin && this.player.FreeWheelPlugin.adsManager && this.player.FreeWheelPlugin.adsManager.getCurrentAd()) {
            var index = this.player.FreeWheelPlugin.adsManager.getCurrentAd().getAdPodInfo().getPodIndex()
            if (index === 0) {
                return 'pre'
            } else if (index === -1) {
                return 'post'
            } else if (index > 0) {
                return 'mid'
            } else {
                return 'unknown'
            }
        } else {
            if (!this.plugin._adapter.flags.isJoined) {
                return 'pre'
            } else if (this.plugin._adapter.getPlayhead() >= this.plugin._adapter.getDuration()) {
                return 'post'
            } else {
                return 'mid'
            }
        }
    },

    getResource: function () {
        return "unknown"
    },

    getTitle: function () {
        if (this.player.FreeWheelPlugin) {
            if (this.player.FreeWheelPlugin.adsManager && this.player.FreeWheelPlugin.adsManager.getCurrentAd()) {
                return this.player.FreeWheelPlugin.adsManager.getCurrentAd().getTitle()
            }
        } else if (this.player.ima3 && this.player.ima3.currentAd.g) {
            return this.player.ima3.currentAd.g.title
        }
        return null
    },

    getPlayhead: function () {
        var player = this.plugin.getAdapter().player
        if (this.player.FreeWheelPlugin) {
            if (this.player.FreeWheelPlugin.adPlayer) {
                player = this.player.FreeWheelPlugin.adPlayer
            }
        } else if (this.player.ima3) {
            if (this.player.ima3 && this.player.ima3.adPlayer) {
                player = this.player.ima3.adPlayer
            }
        }
        return player.currentTime()
    },

    getPlayerVersion: function () {
        if (this.player.ima3)
            return this.player.ima3.VERSION
        return null
    },

    registerListeners: function () {
        // Enable playhead monitor
        this.monitorPlayhead(true, false)

        /*youbora.Util.logAllEvents(this.player.on, [
            null,
            'ima3-ready',
            'ima3error',
            'ima3-ad-error',
            'ima3-started',
            'ima3-complete',
            'ima3-paused',
            'ima3-resumed',
            'ads-request',
            'ads-load',
            'ads-ad-started',
            'ads-ad-ended',
            'ads-pause',
            'ads-play',
            'ads-click',
            'ads-pod-started',
            'ads-pod-ended',
            'ads-allpods-completed'
        ])*/
        this.references = []
        if (this.player.ima3) {
            // Register listeners
            this.references['ima3-started'] = this.startJoinListener.bind(this)
            this.references['ima3-paused'] = this.pausedListener.bind(this)
            this.references['ima3-resumed'] = this.resumedListener.bind(this)
            this.references['ima3-complete'] = this.adEndedListener.bind(this)
            this.references['ima3-skipped'] = this.skippedListener.bind(this)
            this.references['ima3-ad-error'] = this.errorListener.bind(this)
        } else if (this.player.FreeWheelPlugin) {
            // Register listeners
            this.references['ads-ad-started'] = this.startJoinListener.bind(this)
            this.references['ads-pause'] = this.pausedListener.bind(this)
            this.references['ads-play'] = this.resumedListener.bind(this)
            this.references['ads-ad-ended'] = this.adEndedListener.bind(this)
            this.references['ads-click'] = this.clickListener.bind(this)
        }

        if (this.player) Object.keys(this.references).forEach(function (key) { this.player.on(key, this.references[key]) }.bind(this))
    },

    startJoinListener: function (e) {
        if (this.plugin._adapter) this.plugin._adapter.firePause()
        this.fireStart()
        this.fireJoin()
    },

    loadedListener: function (e) {
        this.fireStart()
    },

    contentPauseRequestedListener: function (e) {
        this.fireStart()
    },

    startedListener: function (e) {
        this.fireJoin()
    },

    pausedListener: function (e) {
        this.firePause()
    },

    resumedListener: function (e) {
        this.fireResume()
    },

    completeListener: function (e) {
        this.fireStop()
        if (this.plugin._adapter) this.plugin._adapter.fireResume()
    },

    skippedListener: function (e) {
        this.fireSkip()
        if (this.plugin._adapter) this.plugin._adapter.fireResume()
    },

    adEndedListener: function (e) {
        this.fireStop()
    },

    errorListener: function (e) {
        if (e.getError && e.getError()) {
            var error = e.getError()
            this.fireError(error.getCode(), error.getMessage())
        } else {
            this.fireError('Ad error')
        }
    },

    clickListener: function (e) {
        var clickurl = null
        if (this.player.ima3 && this.player.ima3.currentAd && this.player.ima3.currentAd.g) {
            clickurl = this.player.ima3.currentAd.g.clickThroughUrl
        }
        this.fireClick(clickurl)
    },

    unregisterListeners: function () {
        // Disable playhead monitoring
        if (this.monitor) this.monitor.stop()

        // unregister listeners
        if (this.player && this.references) {
            Object.keys(this.references).forEach(function (key) { this.player.off(key, this.references[key]) }).bind(this)
            this.references = []
        }
    }
})

module.exports = FreewheelAdsAdapter
